/** Chapters as numbered rows; a long list shows `shown` and "All N chapters", as New paper does. */
import { useState } from "react";
import { chapterTitle } from "./chapters";

type Props = {
  chapters: { number: number; title: string }[];
  /** Rows before "All N chapters"; omitted, every row shows. */
  shown?: number;
};

export function ChapterList({ chapters, shown }: Props) {
  const [all, setAll] = useState(shown === undefined || chapters.length <= shown + 1);
  const rows = all ? chapters : chapters.slice(0, shown);
  return (
    <>
      <ol className="chapter-list">
        {rows.map((c) => (
          <li key={c.number} className="chapter-list__row">
            <span className="chapter-list__num num">{c.number}</span>
            <span>{chapterTitle(c.title)}</span>
          </li>
        ))}
      </ol>
      {!all && (
        <button type="button" className="new-paper__all" onClick={() => setAll(true)}>
          All {chapters.length} chapters
        </button>
      )}
    </>
  );
}
